import Axios from "axios";

export class PjService {

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pj/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pj/editar`, data).then(res => res.data);
    }

    consultar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pj/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    eliminar(id, opciones = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pj/eliminar/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pj/reporte/${id}`, 
            { headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob', params: opciones }).then(async res => res.data);
    }
}
